import axios from 'axios'
import { Notification, MessageBox } from 'element-ui'
import store from '@/store'


axios.defaults.headers['Content-Type'] = 'application/json;charset=utf-8'
// 创建axios实例
const service = axios.create({
  // axios中请求配置有baseURL选项，表示请求URL公共部分
  // baseURL: 'http://106.13.229.124:11575/',
  // baseURL: 'http://47.97.209.208:7111/api/',
  baseURL: 'api/',
  // 超时
  timeout: 30000
})

// request拦截器
service.interceptors.request.use(config => {
  if (config.isToken) {
    config.headers.Authorization = localStorage.getItem('userToken')
  }
  return config
}, error => {
  Promise.reject(error)
})

// 响应拦截器
service.interceptors.response.use(res => {
    // 未设置状态码则默认成功状态
    const code = res.data.code || 200;
    // 获取错误信息
    const msg = res.data.msg || '请求失败'
    // 二进制数据则直接返回
    if(res.request.responseType ===  'blob' || res.request.responseType ===  'arraybuffer'){
      return res.data
    }
    if (code === 401) {
      MessageBox.alert("温馨提示", "登录状态已过期，请重新登录", {
        confirmButtonText: "确定",
        callback: action => {
          localStorage.removeItem("userToken");
          localStorage.removeItem("userName");
          store.dispatch('app/setVisible', true)
        }
      });
      return Promise.reject('无效的会话，或者会话已过期，请重新登录。')
    } else if (code === 500) {
      return Promise.reject(new Error(msg))
    } else if (code !== 200) {
      Notification.error({
        title: msg
      })
      return Promise.reject('error')
    } else {
      return res.data
    }
  },
  error => {
    // console.log('err' + error)
    let { message } = error;
    if (message == "Network Error") {
      message = "后端接口连接异常";
    }
    else if (message.includes("timeout")) {
      message = "系统接口请求超时";
    }
    else if (message.includes("Request failed with status code")) {
      message = "系统接口" + message.substr(message.length - 3) + "异常";
    }
    return Promise.reject(message)
  }
)

export default service


// WEBPACK FOOTER //
// ./src/network/request.js